import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("div", [_c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    on: {
      input: function input($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: ""
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("待处理 "), _vm.waitNum && _vm.waitNum["0"] ? _c("span", {
    staticClass: "waitNum"
  }, [_vm._v(_vm._s(_vm.waitNum["0"]))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("待确认 "), _vm.waitNum && _vm.waitNum["1"] ? _c("span", {
    staticClass: "waitNum"
  }, [_vm._v(_vm._s(_vm.waitNum["1"]))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("待退款 "), _vm.waitNum && _vm.waitNum["2"] ? _c("span", {
    staticClass: "waitNum"
  }, [_vm._v(_vm._s(_vm.waitNum["2"]))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("待开票 "), _vm.waitNum && _vm.waitNum["3"] ? _c("span", {
    staticClass: "waitNum"
  }, [_vm._v(_vm._s(_vm.waitNum["3"]))]) : _vm._e()])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    on: {
      input: function input($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "4"
    }
  }, [_vm._v("已确认")]), _c("el-radio-button", {
    attrs: {
      label: "5"
    }
  }, [_vm._v("已退款")]), _c("el-radio-button", {
    attrs: {
      label: "6"
    }
  }, [_vm._v("已开票")])], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "流水编号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入流水编号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.receiptWaterNbr,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "receiptWaterNbr", $$v);
      },
      expression: "searchForm.receiptWaterNbr"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "打款方"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入打款方"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.payer,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "payer", $$v);
      },
      expression: "searchForm.payer"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "收款主体"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择收款主体"
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.payeeAccount,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "payeeAccount", $$v);
      },
      expression: "searchForm.payeeAccount"
    }
  }, _vm._l(_vm.payeeList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "公司"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "small",
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      placeholder: "请输入公司",
      "remote-method": _vm.remoteMethod,
      loading: _vm.companyLoading
    },
    on: {
      change: _vm.selectCompany
    },
    model: {
      value: _vm.searchForm.companyId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "companyId", $$v);
      },
      expression: "searchForm.companyId"
    }
  }, _vm._l(_vm.companyList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.companyName,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "合同编号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入合同编号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.contractNo,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "contractNo", $$v);
      },
      expression: "searchForm.contractNo"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          pageNum: 1,
          pageSize: 20,
          receiptWaterNbr: "",
          payer: "",
          payeeAccount: "",
          contractNo: "",
          companyId: "",
          companyName: "",
          status: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")]), _c("el-button", {
    attrs: {
      type: "success",
      loading: _vm.loadingRefresh
    },
    on: {
      click: _vm.refreshOrigin
    }
  }, [_vm._v("刷新 ")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "contractNumber",
      label: "收款流水编号",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.receiptWaterNbr))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "payer",
      label: "打款方",
      width: "200"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "payeeCompany",
      label: "收款方",
      width: "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          payeeCompany = _ref$row.payeeCompany,
          dataSource = _ref$row.dataSource;
        return [_vm._v(" " + _vm._s(payeeCompany) + " "), _c("SourceTag", {
          attrs: {
            type: dataSource
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "payeeAccount",
      label: "收款账户",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var payeeAccount = _ref2.row.payeeAccount;
        return [_vm._v(" " + _vm._s(payeeAccount) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "receiptAmount",
      label: "收款金额",
      width: "140",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var receiptAmount = _ref3.row.receiptAmount;
        return [_vm._v(" " + _vm._s(_vm.formatThousands(receiptAmount)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "receiptTime",
      label: "状态",
      width: "100",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var status = _ref4.row.status;
        return [status === "0" ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待处理")]) : status === "1" ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("待确认")]) : status === "2" ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("待退款")]) : status === "3" ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("待开票")]) : status === "4" ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已确认")]) : status === "5" ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v(" 已退款")]) : status === "6" ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已开票")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "associateContract",
      label: "关联合同",
      width: "180",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var associateContract = _ref5.row.associateContract;
        return [associateContract ? _c("el-link", {
          attrs: {
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.$router.push("/signing/list?contractNumber=".concat(associateContract));
            }
          }
        }, [_vm._v(_vm._s(associateContract) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "associateCompany",
      label: "关联公司",
      width: "180",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var _ref6$row = _ref6.row,
          associateCompany = _ref6$row.associateCompany,
          companyName = _ref6$row.companyName;
        return [companyName ? _c("el-link", {
          attrs: {
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.$router.push("/quarter/company?companyName=".concat(companyName));
            }
          }
        }, [_vm._v(_vm._s(companyName) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "depositAmount",
      label: "押金金额",
      width: "140",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var depositAmount = _ref7.row.depositAmount;
        return [_vm._v(" " + _vm._s(_vm.formatThousands(depositAmount)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "orderAmount",
      label: "订单金额",
      width: "140",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var orderAmount = _ref8.row.orderAmount;
        return [_vm._v(" " + _vm._s(_vm.formatThousands(orderAmount)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "returnSlip",
      label: "电子回单",
      width: "160",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var _ref9$row = _ref9.row,
          returnSlip = _ref9$row.returnSlip,
          slipIdentical = _ref9$row.slipIdentical,
          dataSource = _ref9$row.dataSource;
        return [returnSlip && dataSource === "ALIPAY" ? [_c("div", {
          class: slipIdentical === "1" ? "wlc-button-succes" : "wlc-button-danger",
          staticStyle: {
            "font-size": "12px",
            "margin-bottom": "10px"
          }
        }, [_vm._v(" 系统识别：流水" + _vm._s(slipIdentical === "1" ? "" : "不") + "一致 ")]), _c("div", {
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_c("wlc-image", {
          attrs: {
            src: returnSlip,
            list: [returnSlip],
            width: "22",
            compression: true
          }
        })], 1)] : returnSlip && dataSource === "CMB" ? _c("div", [_c("el-link", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.previewPdf(returnSlip);
            }
          }
        }, [_vm._v("查看回单")])], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "bill",
      label: "发票凭证",
      width: "140",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref0) {
        var bill = _ref0.row.bill;
        return [bill ? _c("el-link", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.previewPdf(bill);
            }
          }
        }, [_vm._v("查看发票")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "reimburseSerialNumber",
      label: "退款凭证",
      width: "180",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref1) {
        var _ref1$row = _ref1.row,
          reimburseSerialNumber = _ref1$row.reimburseSerialNumber,
          dataSource = _ref1$row.dataSource,
          reimburse = _ref1$row.reimburse;
        return [reimburse ? [_c("div", {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v(" " + _vm._s(reimburseSerialNumber) + " ")]), dataSource === "CMB" ? _c("div", {
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_c("el-link", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.previewPdf(reimburse);
            }
          }
        }, [_vm._v("查看退款回单")])], 1) : _c("div", {
          staticStyle: {
            "font-size": "14px",
            "margin-top": "10px"
          }
        }, [reimburse ? _c("wlc-image", {
          attrs: {
            src: reimburse,
            list: [reimburse],
            width: "22",
            compression: true
          }
        }) : _vm._e()], 1)] : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "receiptTime",
      label: "入账时间",
      width: "100",
      align: "right"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "action",
      width: "180",
      fixed: "right",
      label: "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var row = _ref10.row;
        return [_c("div", {
          staticClass: "action-buttons"
        }, [row.status === "0" ? [_c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.connect(row);
            }
          }
        }, [_vm._v("关联")]), _c("ConfirmPopover", {
          attrs: {
            title: "申请退款",
            content: "确认申请退款？",
            width: "240"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.applyRefund($event, row);
            }
          }
        }, [_c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            slot: "reference",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("申请退款")])], 1), _c("ConfirmPopover", {
          attrs: {
            title: "剔除数据",
            content: "是否确认该笔收款非季度收款？",
            width: "240"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteRecord($event, row);
            }
          }
        }, [_c("div", {
          staticClass: "delete-info",
          attrs: {
            slot: "content"
          },
          slot: "content"
        }, [_c("span", [_vm._v("交易金额：" + _vm._s(_vm.formatThousands((row === null || row === void 0 ? void 0 : row.receiptAmount) || 0)) + "元")]), _c("span", [_vm._v("打款方：" + _vm._s((row === null || row === void 0 ? void 0 : row.payer) || ""))]), _c("span", [_vm._v("收款方：" + _vm._s((row === null || row === void 0 ? void 0 : row.payeeCompany) || "") + " "), _c("SourceTag", {
          attrs: {
            size: "mini",
            zoom: 0.7,
            type: row.dataSource
          }
        })], 1)]), _c("el-button", {
          staticClass: "wlc-button-warning",
          attrs: {
            slot: "reference",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("剔除")])], 1)] : _vm._e(), row.status === "1" ? [_c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.connect(row);
            }
          }
        }, [_vm._v("编辑")]), _vm.isFinance ? [_c("ConfirmOrder", {
          attrs: {
            title: "确认款项",
            isConfirm: "",
            width: "305",
            row: row,
            confirmText: "确认收款"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmPayment($event, row);
            }
          }
        }, [_c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            slot: "reference",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("确认")])], 1), _c("ConfirmOrder", {
          attrs: {
            title: "拒绝款项",
            width: "305",
            row: row,
            confirmText: "拒绝收款"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.refundPayment($event, row);
            }
          }
        }, [_c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            slot: "reference",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("拒绝")])], 1)] : _vm._e()] : _vm._e(), row.status === "4" ? [_c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.showApplyInvoice(row);
            }
          }
        }, [_vm._v("申请开票")])] : _vm._e(), _vm.isFinance ? [row.status === "2" ? _c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.addRefund(row);
            }
          }
        }, [_vm._v("确认退款 ")]) : _vm._e(), row.status === "5" ? _c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.editRefund(row);
            }
          }
        }, [_vm._v("修改退款信息 ")]) : _vm._e()] : _vm._e(), _vm.isFinance ? [row.status === "3" ? _c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.confirmInvoice(row);
            }
          }
        }, [_vm._v("确认开票 ")]) : _vm._e(), row.status === "6" ? _c("el-button", {
          staticClass: "wlc-button-success",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.editInvoice(row);
            }
          }
        }, [_vm._v("修改发票信息 ")]) : _vm._e()] : _vm._e()], 2)];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("PaymentConnect", {
    ref: "paymentConnect",
    attrs: {
      companyList: _vm.companyList
    },
    on: {
      confirm: _vm.getData
    }
  }), _c("RefundForm", {
    ref: "refundForm",
    on: {
      confirm: _vm.getData
    }
  }), _c("InvoiceForm", {
    ref: "invoiceForm",
    on: {
      confirm: _vm.getData
    }
  }), _c("el-dialog", {
    attrs: {
      title: "申请开票",
      width: "400px",
      visible: _vm.applyInvoiceVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.applyInvoiceVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "开票类型",
      "label-width": "80px"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.applyInvoiceData.invoiceType,
      callback: function callback($$v) {
        _vm.$set(_vm.applyInvoiceData, "invoiceType", $$v);
      },
      expression: "applyInvoiceData.invoiceType"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "0",
      border: ""
    }
  }, [_vm._v("普通发票")]), _c("el-radio", {
    attrs: {
      label: "1",
      border: ""
    }
  }, [_vm._v("专用发票")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "开票公司",
      "label-width": "80px"
    }
  }, [_vm.currentRow.invoicingCompany ? _c("div", [_vm._v(_vm._s(_vm.currentRow.invoicingCompany))]) : _c("el-input", {
    model: {
      value: _vm.applyInvoiceData.invoicingCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.applyInvoiceData, "invoicingCompany", $$v);
      },
      expression: "applyInvoiceData.invoicingCompany"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "开票税号",
      "label-width": "80px"
    }
  }, [_vm.currentRow.invoicingTaxNumber ? _c("div", [_vm._v(_vm._s(_vm.currentRow.invoicingTaxNumber))]) : _c("el-input", {
    model: {
      value: _vm.applyInvoiceData.invoicingTaxNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.applyInvoiceData, "invoicingTaxNumber", $$v);
      },
      expression: "applyInvoiceData.invoicingTaxNumber"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.applyInvoiceVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.applyInvoice
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };